import dayjs from "dayjs";

export default class DateFormatter {
    public static formatDate(date?: Date | null) : string | null {
        if (!date) return null;
        return dayjs(date!).format("YYYY-MM-DD");
    }
}